export const preferredCitation = {
  authors:
    'Matthew Cannon, James Stevenson, Kathryn Stahl, Rohit Basu, Adam Coffman, Susanna Kiwala, Joshua F McMichael, Kori Kuzma, Dorian Morrissey, Kelsy Cotto, Elaine R Mardis, Obi L Griffith, Malachi Griffith, Alex H Wagner',
  title:
    'DGIdb 5.0: rebuilding the drug–gene interaction database for precision medicine and drug discovery platforms',
  journal: 'Nucleic Acids Research',
  volumeIssuePages: 'Volume 52, Issue D1, 5 January 2024, Pages D1227–D1235,',
  doi: 'https://doi.org/10.1093/nar/gkad1040',
};

export const pastCitations = [
  {
    authors:
      'Sharon L Freshour, Susanna Kiwala, Kelsy C Cotto, Adam C Coffman, Joshua F McMichael, Jonathan J Song, Malachi Griffith, Obi L Griffith, Alex H Wagner',
    title:
      'Integration of the Drug–Gene Interaction Database (DGIdb 4.0) with open crowdsource efforts',
    journal: 'Nucleic Acids Research',
    volumeIssuePages: 'Volume 49, Issue D1, 8 January 2021, Pages D1144–D1151,',
    doi: 'https://doi.org/10.1093/nar/gkaa1084',
  },
  {
    authors:
      'Kelsy C Cotto, Alex H Wagner, Yang-Yang Feng, Susanna Kiwala, Adam C Coffman, Gregory Spies, Alex Wollam, Nicholas C Spies, Obi L Griffith, Malachi Griffith',
    title:
      'DGIdb 3.0: a redesign and expansion of the drug–gene interaction database',
    journal: 'Nucleic Acids Research',
    volumeIssuePages: 'Volume 46, Issue D1, 4 January 2018, Pages D1068–D1073,',
    doi: 'https://doi.org/10.1093/nar/gkx1143',
  },
  {
    authors:
      'Alex H. Wagner, Adam C. Coffman, Benjamin J. Ainscough, Nicholas C. Spies, Zachary L. Skidmore, Katie M. Campbell, Kilannin Krysiak, Deng Pan, Joshua F. McMichael, James M. Eldred, Jason R. Walker, Richard K. Wilson, Elaine R. Mardis, Malachi Griffith, Obi L. Griffith',
    title: 'DGIdb 2.0: mining clinically relevant drug–gene interactions',
    journal: 'Nucleic Acids Research',
    volumeIssuePages: 'Volume 44, Issue D1, 4 January 2016, Pages D1036–D1044',
    doi: 'https://doi.org/10.1093/nar/gkv1165',
  },
  {
    authors:
      'Malachi Griffith, Obi L. Griffith, Adam C. Coffman, James V. Weible, Joshua F. McMichael, Nicholas C. Spies, James Koval, Indraniel Das, Matthew B. Callaway, James M. Eldred, Christopher A Miller, Janakiraman Subramanian, Ramaswamy Govindan, Runjun D Kumar, Ron Bose, Li Ding, Jason R. Walker, David E. Larson, David J. Dooling, Scott M. Smith, Timothy J. Ley, Elaine R. Mardis, Richard K. Wilson.',
    title: 'DGIdb: mining the druggable genome',
    journal: 'Nature Methods',
    volumeIssuePages: 'Volume 10, Issue 12, December 2013, Pages 1209-1210',
    doi: 'https://doi.org/10.1038/nmeth.2689',
  },
];
